<template>
  <div class="media-popup">
    <button class="btn btn__close" @click.prevent="closePopup"></button>
    <media-files></media-files>
  </div>
</template>

<script>
import mediaFiles from './files'
export default {
  props: {
    field: {
      type: String
    }
  },
  components: {mediaFiles},
  created: function () {
    this.$on('image', img => {
      this.$parent.$emit(this.field, img)
      this.$emit('close')
    })
  },
  mounted: function () {
    document.addEventListener('keydown', e => {
      if (e.keyCode === 27) {
        this.closePopup()
      }
    })
  },
  methods: {
    closePopup: function () {
      if (this.$route.name === 'ckMedia') {
        window.close()
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/components/_home"
@import "../../assets/sass/components/_forms"
</style>


// WEBPACK FOOTER //
// src/components/media/popup.vue